import type { Role } from '../api/queries/roles';

/** Always on; the others are optional and switched in Settings (ADR 0028). */
const ALWAYS_ON: readonly Role[] = ['admin', 'supervisor', 'rep'];

/**
 * Whether a role may be offered: always-on roles, the optional roles switched on
 * (`enabled`, from useEnabledRoles; undefined while it loads), and any role in `kept`
 * (one a user or notice already has: it stays, and shows, while switched off).
 */
export function offersRole(
  enabled: readonly Role[] | undefined,
  role: Role,
  kept: readonly Role[] = [],
) {
  return ALWAYS_ON.includes(role) || !!enabled?.includes(role) || kept.includes(role);
}
